module.exports = __webpack_public_path__ + "static/wakepark-customer-visual-362e9ce75f8645242d6dbff3ac574c88.jpg";